import React from 'react';
import styled from '@emotion/styled';
import CheckIcon from '../../icons/CheckIcon';
import InProgressIcon from '../../icons/InProgressIcon';
import ErrorIcon from '../../icons/ErrorIcon';
import WarningIcon from '../../icons/WarningIcon';
import { StatusType } from './StatusType';

const StatuslabelSpan = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  word-break: normal;
  line-height: 1em;
`;
const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.5625rem;
  font-size: 0.875rem;
  text-align: center;
  height: 28px;
  padding: 0 0.75rem;
  svg {
    max-width: 1rem;
    max-height: 1rem;
    width: 1rem;
    height: 1rem;
    margin-right: 4px;
  }
`;
const GreenBadge = styled(Badge)`
  background: #d4e8ad;
  color: #5c9901;
`;
const RedBadge = styled(Badge)`
  background: #f8dbde;
  color: #ce1126;
`;
const YellowBadge = styled(Badge)`
  background: #fbe3a3;
  color: #d5a00e;
`;
const PurpleBadge = styled(Badge)`
  background: #e9dfed;
  color: #9746cb;
`;

export interface StatusBadgeProps {
  status: StatusType | string;
}

export const StatusBadge = (props: StatusBadgeProps) => {
  const { status } = props;

  switch (status) {
    case StatusType.COMPLETE:
      return (
        <StatuslabelSpan>
          <GreenBadge>
            <CheckIcon></CheckIcon>
            {status}
          </GreenBadge>
        </StatuslabelSpan>
      );
    case StatusType.ERROR:
      return (
        <StatuslabelSpan>
          <RedBadge>
            <ErrorIcon />
            {status}
          </RedBadge>
        </StatuslabelSpan>
      );
    case StatusType.INCOMPLETE:
      return (
        <StatuslabelSpan>
          <YellowBadge>
            <WarningIcon />
            {status}
          </YellowBadge>
        </StatuslabelSpan>
      );
    default:
      return (
        <StatuslabelSpan>
          <PurpleBadge>
            <InProgressIcon />
            {status}
          </PurpleBadge>
        </StatuslabelSpan>
      );
  }
};

export default StatusBadge;
